module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<hr class="hidden"/>\n<div class="panetitle panetitle-main">\n    Document\n</div>\n\n<div id="header" class="header-container">\n  <div class="survey-header" alt="Pension Survey header"></div>\n</div>\n\n<div class="inner" id="top">\n  <h3>Use the left menu to select current/archived surveys, or search for surveys between specific dates.</h3>\n</div> <!--/.inner-->';
}
return __p;
};
